import { ListSubheader, Menu, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { RegionEvacZoneStyle, EvacZoneStatus } from 'shared/types';
import { EvacZonesFilter } from 'features/evacZones/types';
import { getEnabledEvacZoneStatuses } from 'features/evacZones/utils';
import { EVAC_ZONE_LABEL_TRANS_KEYS } from '../../../../constants';

export type CopyMenuProps = {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  evacZoneStyles: RegionEvacZoneStyle[];
  handleCopyZones: (filterZonesForCopying: EvacZonesFilter) => void;
};

export const CopyMenu = ({
  anchorEl,
  open,
  onClose,
  evacZoneStyles,
  handleCopyZones,
}: CopyMenuProps): JSX.Element => {
  const { t } = useTranslation();

  const enabledStatuses = getEnabledEvacZoneStatuses(evacZoneStyles);

  // choose a style for texts
  const evacZoneStyle = evacZoneStyles[0];

  const handleClick = (
    selectedStatus: EvacZoneStatus,
    newOnly: boolean,
  ): void => {
    handleCopyZones((evacZone, status) => {
      if (status !== selectedStatus) {
        return false;
      }
      if (newOnly) {
        return evacZone.status !== status;
      }
      return true;
    });
    onClose();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      sx={{
        '& .MuiMenu-paper': { width: 200, height: 'auto', maxHeight: 'none' },
      }}
    >
      <ListSubheader>
        {t('geoEventEvacuations.evacZones.table.copyAll')}
      </ListSubheader>
      {enabledStatuses.map((status) => (
        <MenuItem
          key={`copy-${status}`}
          onClick={() => {
            handleClick(status, false);
          }}
        >
          {t(`${EVAC_ZONE_LABEL_TRANS_KEYS[evacZoneStyle][status]}Short`)}
        </MenuItem>
      ))}
      <ListSubheader>
        {t('geoEventEvacuations.evacZones.table.copyChanged')}
      </ListSubheader>
      {enabledStatuses.map((status) => (
        <MenuItem
          key={`copy-${status}`}
          onClick={() => {
            handleClick(status, true);
          }}
        >
          {t(`${EVAC_ZONE_LABEL_TRANS_KEYS[evacZoneStyle][status]}Short`)}
        </MenuItem>
      ))}
    </Menu>
  );
};
